import { useSyncExternalStore } from 'react';

import styles from './Shell.module.css';

function subscribe(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
}

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return <div className={styles.offline} role="status">You’re offline. Some content may be unavailable or out of date. Reconnect to continue.</div>;
}
